import React from "react";
import { useTranslation } from "react-i18next";
import bankidLogo from "../images/BankID_logo_black.png"; // ✅ Correct path from src/images

const BankIDLogin = ({ onSuccess }) => {
  const { t } = useTranslation();

  const handleLogin = () => {
    const userData = {
      name: "Anna Svensson",
      email: "anna.svensson@bankid.com",
    };
    onSuccess(userData);
  };

  return (
    <button className="bankid-login-btn" onClick={handleLogin}>
      <img
        src={bankidLogo}
        alt="BankID"
        className="bankid-icon"
      />
      {t("login.bankid_sign_in")}
    </button>
  );
};

export default BankIDLogin;